import React, { useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import ButtonActionIcon from "../ButtonActionIcon";
import JobConfigration from "./JobConfigration";
import Button from "../../FormComponents/Button";
import Label from "../../FormComponents/Label";

const SingleJobPopup = ({
  config,
  templateObject = {},
  allJobs,
  smId,
  device,
  onChange,
  label = "",
  type = "statemachine"
}) => {
  const [jobOpen, setJobOpen] = useState(false);
  return (
    <>
      {!config?.job_id && (
        <div
          className="builder_form"
          style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
        >
          {label && <Label>{label}</Label>}
          <Button variant="secondary" onClick={() => setJobOpen(true)}>
            Assign job
          </Button>
        </div>
      )}

      {config?.job_id && !jobOpen && (
        <>
          <label className="builder_label">{label}</label>
          <div className="job_single_card rightpanel overflow_hidden">
            <div className="overlay_cover"></div>
            <div className="job_action_btn">
              <ButtonActionIcon size="sm" type="edit" onClick={() => setJobOpen(true)} />
              <ButtonActionIcon
                size="sm"
                type="delete"
                onClick={() => {
                  onChange({
                    job_id: "",
                    params: null,
                    job_template: ""
                  });
                  setJobOpen(false);
                }}
              />
            </div>
            <JobConfigration
              editJob={{
                job_id: config?.job_id,
                params: config?.params
              }}
              templateObject={templateObject}
              allJobs={allJobs}
              isReadOnly={true}
              smId={smId}
              device={device}
              type={type}
            />
          </div>
        </>
      )}

      <BuilderModal isOpen={jobOpen} onClose={() => setJobOpen(false)} modalName="Add job">
        <JobConfigration
          editJob={
            config?.job_id
              ? {
                  job_id: config?.job_id,
                  params: config?.params
                }
              : null
          }
          templateObject={templateObject}
          allJobs={allJobs}
          onClick={(data) => {
            onChange(data);
            setJobOpen(false);
          }}
          smId={smId}
          device={device}
          type={type}
        />
      </BuilderModal>
    </>
  );
};

export default SingleJobPopup;
